// extracted by mini-css-extract-plugin
export default {"news-list":"List_news-list__iwm2v","no-data":"List_no-data__L9DAJ"};